import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
// import Navbar from "../../components/Navbar";
// import Footer from "../../components/Footer";
import { BASE_URL } from "../../apis/apis";
import { parsal_img } from "../../assets/mediaCall";
import { jwtDecode } from "jwt-decode";

const DeleteAccount = () => {
  const [searchParams] = useSearchParams();
  const key = searchParams.get("key");
  const isDemo = !key;
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("initial");
  // confirm | loading | success | error | expired | invalid
  const [showModal, setShowModal] = useState(false);
  const [userName, setUserName] = useState("");
  const [userType, setUserType] = useState("customer");
  useEffect(() => {
    if (key) {
      try {
        const decoded = jwtDecode(key);

        setUserName(decoded.name || "User");
        setUserType(decoded.userType || "customer");
      } catch {
        setUserName("User");
        setUserType("customer");
      }
    }
  }, [key]);

  const getSuccessRedirect = () => {
    if (userType === "driver" || userType === "partner") {
      return "parsalpartner://Login";
    }

    return "parsalapp://EnterNumberScreen";
  };

  const getCancelRedirect = () => {
    if (userType === "driver" || userType === "partner") {
      return "parsalpartner://Setting";
    }

    return "parsalapp://ProfileScreen";
  };

  const handleDelete = async () => {
    try {
      setLoading(true);

      const res = await axios.post(BASE_URL + "generic/delete-account", {
        key,
      });

      if (res.data.success) {
        setStatus("success");
        window.location.href = getSuccessRedirect();
        // window.location.href = "parsalapp://EnterNumberScreen";
        // window.location.href = "parsalpartner://Login";
      } else {
        setStatus("error");
      }
    } catch (err) {
      if (err.response?.data?.message?.includes("expired")) {
        setStatus("expired");
      } else {
        setStatus("error");
      }
    } finally {
      setLoading(false);
      setShowModal(false);
    }
  };

  //   const handleDelete = async () => {
  //     if (!key) {
  //       setStatus("invalid");
  //       return;
  //     }

  //     try {
  //       setLoading(true);

  //       // ⏳ simulate API delay (optional)
  //       setTimeout(() => {
  //         setStatus("success");
  //         window.location.href = "parsalapp://EnterNumberScreen";
  //         setLoading(false);
  //       }, 1000);
  //     } catch (err) {
  //       setStatus("error");
  //       setLoading(false);
  //     }
  //   };

  const renderContent = () => {
    if (isDemo) {
      return (
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4">
            Delete Your Parsal Account
          </h2>

          {/* <p className="mb-4 text-gray-600">
            You can delete your account directly from the Parsal mobile app.
          </p> */}
          <p className="mb-4 text-gray-600">
            For security reasons, account deletion is processed through the
            Parsal mobile app or verified requests.
          </p>

          <div className="text-left text-gray-700 mb-6">
            <p className="mb-2 font-semibold">Steps:</p>
            <ol className="list-decimal ml-6 space-y-1">
              <li>Open the Parsal app</li>
              <li>Go to Profile / Settings</li>
              <li>Tap on "Delete Account"</li>
              <li>Confirm your request</li>
            </ol>
          </div>

          <p className="mb-4 text-gray-600">
            Alternatively, you can request account deletion by contacting us:
          </p>

          <p className="font-semibold">support@parsal.in</p>

          <p className="mt-6 text-sm text-gray-500">
            Once requested, your account and associated data will be permanently
            deleted.
          </p>
        </div>
      );
    }
    switch (status) {
      case "initial":
        return (
          <div className="text-center">
            <h2 className="text-xl mb-2">
              Hello <span className="font-semibold">{userName}</span>,
            </h2>

            <p className="mb-6 text-gray-600">
              Would you like to delete your account?
            </p>

            <div className="flex justify-center gap-4">
              <button
                onClick={() => setShowModal(true)}
                className="bg-indigo-600 text-white px-6 py-2 rounded-lg"
              >
                Yes
              </button>

              <button
                onClick={() => {
                  // window.location.href = "parsalapp://ProfileScreen"
                  window.location.href = getCancelRedirect();
                }}
                className="bg-gray-200 px-6 py-2 rounded-lg"
              >
                No
              </button>
            </div>
          </div>
        );

      case "success":
        return (
          <div className="text-center">
            <h2 className="text-2xl font-bold text-green-600 mb-4">
              Account Deleted
            </h2>
            <p className="mb-6">Your account has been successfully deleted.</p>

            <button
              onClick={() => {
                window.location.href = getSuccessRedirect();
              }}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg"
            >
              Continue
            </button>
          </div>
        );

      case "confirm":
        return (
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              Delete Account
            </h2>
            <p className="mb-6 text-gray-600">
              Are you sure you want to delete your account? This action cannot
              be undone.
            </p>

            <div className="flex justify-center gap-4">
              <button
                onClick={handleDelete}
                disabled={loading}
                className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 disabled:opacity-50"
              >
                {loading ? "Deleting..." : "Confirm Delete"}
              </button>

              <button
                // onClick={() => setStatus("cancelled")}
                onClick={() => {
                  // window.location.href = "parsalapp://ProfileScreen";
                  window.location.href = getCancelRedirect();
                }}
                className="bg-gray-200 px-6 py-2 rounded-lg hover:bg-gray-300"
              >
                Cancel
              </button>
            </div>
          </div>
        );

      //   case "success":
      //     return (
      //       <div className="text-center">
      //         <h2 className="text-2xl font-bold text-green-600 mb-4">
      //           Account Deleted
      //         </h2>
      //         <p>Your account has been successfully deleted.</p>
      //       </div>
      //     );

      case "expired":
        return (
          <div className="text-center">
            <h2 className="text-2xl font-bold text-yellow-600 mb-4">
              Link Expired
            </h2>
            <p>This link is valid only for 10 minutes.</p>
          </div>
        );

      case "invalid":
        return (
          <div className="text-center">
            <h2 className="text-2xl font-bold text-red-600 mb-4">
              Invalid Link
            </h2>
            <p>The delete link is not valid.</p>
          </div>
        );

      //   case "cancelled":
      //     return (
      //       <div className="text-center">
      //         <h2 className="text-xl font-semibold text-gray-700">
      //           Deletion Cancelled
      //         </h2>
      //       </div>
      //     );

      default:
        return (
          <div className="text-center">
            <h2 className="text-2xl font-bold text-red-600 mb-4">
              Something went wrong
            </h2>
            <p>Please try again later.</p>
          </div>
        );
    }
  };

  return (
    <>
      {/* <Navbar /> */}
      <div className="w-full shadow-sm bg-white">
        <div className="max-w-4xl mx-auto flex items-center h-16 px-4">
          {/* Back Button */}
          {!isDemo && (
            <button
              onClick={() => {
                // window.location.href = "parsalapp://ProfileScreen";
                window.location.href = getCancelRedirect();
              }}
              className="mr-4 text-gray-700 text-lg font-semibold"
            >
              ←
            </button>
          )}

          {/* Logo */}
          <img
            src={parsal_img.logo}
            alt="Parsal Logo"
            className="h-10 mx-auto"
          />
        </div>
      </div>
      {/* bg-white shadow-lg rounded-lg */}
      <div className="max-w-xl mx-auto p-6 my-16 ">{renderContent()}</div>
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg w-[90%] max-w-sm text-center">
            <h3 className="text-lg font-semibold mb-4">
              Are you sure you want to delete your account?
            </h3>

            <div className="flex justify-center gap-4">
              <button
                onClick={handleDelete}
                disabled={loading}
                className="bg-red-600 text-white px-5 py-2 rounded"
              >
                {loading ? "Deleting..." : "Confirm"}
              </button>

              <button
                onClick={() => setShowModal(false)}
                className="bg-gray-200 px-5 py-2 rounded"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DeleteAccount;
